import {
    defaultFont,
    successColor,
    primaryColor,
    warningColor,
    infoColor,
    grayColor
} from "assets/jss/material-dashboard-react.js";
import customInputStyle from "assets/jss/material-dashboard-react/components/customInputStyle";
import checkboxAndRadioStyle from "assets/jss/material-dashboard-react/checkboxAndRadioStyle";

const connectionFormStyle = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        fontWeight: "400",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    },
    formGroupHorizontal: {
        flexDirection: "row"
    },
    formControl: {
        width: "100%"
    },
    itemSpacer: {
        marginTop: "30px"
    },
    groupedInput: {
        marginTop: "0px",
        marginRight: "15px",
        width: "45%"
    },
    fullWidthSelect: {
        width: "100%",
        marginTop: "15px"
    },
    labelComponent: customInputStyle.labelRoot,
    bottomNavigationButtons: {
        display: 'flex',
        justifyContent: 'flex-end',
        "& button": {
            marginLeft: "25px"
        }
    },
    sectionHeader: {
        backgroundColor: primaryColor[1],
        color: "#FFFFFF",
        padding: "9px",
        fontWeight: "400"
    },
    checkBoxText: {
        alignItems: "flex-start",
        marginBottom: "15px",
        marginRight: "5px",
        "& span.MuiCheckbox-root": {
            paddingTop: "2px"
        }
    },
    awareFormCheckbox: {
        alignItems: "flex-start",
        marginBottom: "15px",
        marginRight: "5px",
        color: grayColor[1],
        "& span.MuiCheckbox-root": {
            paddingTop: "2px"
        }
    },
    divider: {
        marginTop: "20px",
        backgroundColor: "rgba(0, 0, 0, 0.5)"
    },
    buttonBox: {
        textAlign: "center",
        margin: "15px 0"
    },
    signingButton: {
        width: "70%",
        fontSize: "16px",
        fontWeight: "500"
    },
    buttonProgress: {
        color: "#ffffff",
        position: 'absolute',
        top: '50%',
        right: '10%',
        marginTop: -12,
        marginLeft: -12,
    },
    ...checkboxAndRadioStyle
};

export default connectionFormStyle;